import { Style } from '@capacitor/status-bar'

export interface StatusBarServiceConfig {
    ignoredRoutes?: string[]
    defaultStatusBarStyle?: Style
}
